import React from "react";
import { redirect } from "react-router-dom"

export async function action({ params }: any) {
  console.log(`DELETE /recipe/${params.recipeId}`)
  return redirect("/");
}
